import { getVoicefileDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const getVoicefileCallable = getCallable(getVoicefileDefinition);
